import { StatusChip } from '@/components/status/StatusChip';

/** A tenant's status (`ResellerTenantView.status`). An unknown status is "—". */
export function TenantStatusChip({ status }: { status: string }) {
  return <StatusChip domain="tenant" status={status} />;
}
